import React, { useCallback, useState } from 'react'
import cancelIcon from '../assets/images/cancel.png'
import renameImage from '../assets/images/rename.png'
const Todo = ({
  todo,
  changeTodosStatus,
  changeTodosColor,
  handleDeleteTodo,
  renameTaskTodoTitle,
  isLoading,
} = {}) => {
  const { completed, text, id, color } = todo
  const [updateTitle, setUpdateTitle] = useState({ text: '', disabled: true })
  const handleRename = (value) => {
    renameTaskTodoTitle({ todo: { ...todo, text: value || text } })
  }

  const debounce = (func, delay) => {
    let timer
    return function (...args) {
      const context = this
      if (timer) clearTimeout(timer)
      timer = setTimeout(() => {
        timer = null
        func.apply(context, args)
      }, delay)
    }
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const optimizedFn = useCallback(debounce(handleRename, 700), [])

  return (
    <div className="flex justify-start items-center p-2 hover:bg-gray-100 hover:transition-all space-x-4 border-b border-gray-400/20 last:border-0">
      <div
        className={`relative rounded-full bg-white border-2 border-gray-400 w-5 h-5 flex flex-shrink-0 justify-center items-center mr-2 ${
          completed && 'border-green-500 focus-within:border-green-500'
        }`}
      >
        <input
          type="checkbox"
          className="opacity-0 absolute rounded-full"
          checked={completed}
          disabled={isLoading}
          onChange={() => changeTodosStatus({ todo: { ...todo, completed: !completed } })}
        />
        {completed && (
          <svg
            className="fill-current w-3 h-3 text-green-500 pointer-events-none"
            viewBox="0 0 20 20"
          >
            <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
          </svg>
        )}
      </div>
      <div className="flex-1">
        <input
          type="text"
          className="w-full p-1"
          disabled={isLoading || updateTitle.disabled}
          value={updateTitle.text || text}
          onChange={(e) => {
            setUpdateTitle({ ...updateTitle.disabled, text: e.target.value })
            optimizedFn(e.target.value)
          }}
        />
      </div>

      <div
        className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer hover:bg-green-500 border-green-500 ${
          color === 'green' && 'bg-green-500'
        }`}
        onClick={() => changeTodosColor({ todo: { ...todo, color: 'green' } })}
      ></div>

      <div
        className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer hover:bg-yellow-500 border-yellow-500 ${
          color === 'yellow' && 'bg-yellow-500'
        }`}
        onClick={() => changeTodosColor({ todo: { ...todo, color: 'yellow' } })}
      ></div>

      <div
        className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer hover:bg-red-500 border-red-500 ${
          color === 'red' && 'bg-red-500'
        }`}
        onClick={() => changeTodosColor({ todo: { ...todo, color: 'red' } })}
      ></div>
      <img
        src={renameImage}
        className="flex-shrink-0 w-4 h-4 ml-2 cursor-pointer"
        alt="Reanme"
        onClick={() => setUpdateTitle({ ...updateTitle, disabled: false })}
      />
      <img
        src={cancelIcon}
        className="flex-shrink-0 w-4 h-4 ml-2 cursor-pointer"
        alt="Cancel"
        onClick={() => handleDeleteTodo(id)}
      />
    </div>
  )
}

export default Todo
